module.exports = __webpack_public_path__ + "static/media/instat-logo-light.fd3e6dd7.png";